import { ADD_PARTNER_MEMBER, LIST_PARTNER_MEMBERS } from "../../gql/members";
import {
  alertError,
  alertSuccess,
  errorHandling,
} from "../../helpers/errorHandling";
import { ApolloClientPartnerService } from "../../services/ApolloClientPartnerService";

/**
 * fetch all Partner members
 * @param {*} param0
 * @returns
 */
export const fetchMembersList = async ({ filter, pagination }) => {
  try {
    const { data } = await ApolloClientPartnerService.query({
      query: LIST_PARTNER_MEMBERS,
      operationName: "LIST_PARTNER_MEMBERS",
      variables: { pagination, filter },
      fetchPolicy: "network-only",
    });
    return data?.listPartnerMembers;
  } catch (e) {
    errorHandling(e);
  }
};

/**
 * add member
 * @param {*} param0
 * @returns
 */
export const addMember = async (input) => {
  try {
    const { data } = await ApolloClientPartnerService.mutate({
      mutation: ADD_PARTNER_MEMBER,
      operationName: "ADD_PARTNER_MEMBER",
      variables: { input },
    });
    const response = data?.createPartnerMember || {};
    alertSuccess("Member added successfully");
    return response;
  } catch (e) {
    alertError(e);
    errorHandling(e);
  }
};
